import {MOBILE_SIDEBAR_CLOSE, MOBILE_SIDEBAR_OPEN, SCREEN_RESIZE} from '../../actions/types';

let defaultState = {
    isMobile: false,
    sidebarOpen: false
};

export default function(state = defaultState, action){
    switch (action.type){
        case MOBILE_SIDEBAR_OPEN:
            return Object.assign({}, state, {sidebarOpen: true});
        case MOBILE_SIDEBAR_CLOSE:
            return Object.assign({}, state, {sidebarOpen: false});
        case SCREEN_RESIZE:
            let isMobile = (action.payload <= 960);
            return Object.assign({}, state, {isMobile});
        default:
            break;
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/Mobile/index.js